import { createContext, FC, useMemo } from 'react'

import { TagFragment } from '~generated/operations'
import { CreateTagData } from '~modules/tags/usecases/useCreateTag'

interface TagsSelectContextProviderProps {
  tags?: TagFragment[]
  onCreate?: (data: CreateTagData) => Promise<TagFragment>
}

export const TagsSelectContext = createContext<TagsSelectContextProviderProps>({ tags: null, onCreate: null })

export const TagsSelectContextProvider: FC<React.PropsWithChildren<TagsSelectContextProviderProps>> = ({
  children,
  tags,
  onCreate,
}) => {
  const value = useMemo(() => ({ tags, onCreate }), [onCreate, tags])

  return <TagsSelectContext.Provider value={value}>{children}</TagsSelectContext.Provider>
}
